// extracted by mini-css-extract-plugin
export var errorIcon = "_m4-1";
export var nameLogo = "_m4-0";